// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d49426d","455":"36bb2a4c","977":"3c2b6875"}[chunkId] + ".chunk.js";
};